import { hasValue } from '../functions/check-empty';
import { regularExpressionValidator } from '../functions/regular-expression-validator';
import { nodeListToArray } from '../helpers/nodeListToArray';
import { isValidPassword } from '../../../App/global/functions/validation';
import { isNullOrUndefined } from 'util';
import { createEvent } from '../helpers/eventCreator';
import '../helpers/closestPolyfill';
import { CountryCombination } from '../../../App/global/state-helpers/input';

const formElementValidClass = 'form-element-valid';
const formElementInvalidClass = 'form-element-invalid';
const DISABLED_BUTTON_ATTRIBUTE = "disable-button";
const DISABLED_BUTTON_CLASS = "disabled";
const FORM_ELEMENT_CLASS = "form-element";
const FORM_ELEMENT_ERROR_CLASS = "form-element-error-text";
const FORM_ELEMENT_REQUIRED_CLASS = "form-element-required";
const UnitedStates = "unitedstates";
const Canada = "canada";
const PostalCodeAttribute = "data-dynamic-postal-code-validation";

/* formValidation adds validation function to every element with 'form-element-input' class that has required attribute on.
Function checks if value is empty and then runs value against regularExpressionValidator that takes in value and type of validation to check against.*/

export function formValidation() {
    initializeSubmitButtons();
    inputValidation();
    inputRadioErrorInitialization();
    inputCheckboxInitialization();
    textareaValidation();
    selectValidation();
    disableLoginButton();
}

// Set up event handlers for submit buttons
const initializeSubmitButtons = () => {
    var inputsWithDisableButton = document.querySelectorAll(`[${DISABLED_BUTTON_ATTRIBUTE}]`);
    if (inputsWithDisableButton) {
        var buttonIds = [];
        // Get a list of unique submit button ids that have an input element targetting it for disabling on validation error
        [].forEach.call(inputsWithDisableButton, (input) => {
            var inputDisableButtonId = getDisableButtonId(input);
            if (!buttonIds.some(buttonId => buttonId === inputDisableButtonId)) {
                buttonIds.push(inputDisableButtonId);
            }
        });

        // Add click handler for each targetted button
        [].forEach.call(buttonIds, (id) => {
            var button = document.getElementById(id);
            if (button) {
                button.addEventListener('click', (e) => onSubmitButtonClicked(e));
            }
        });
    }
}

const onSubmitButtonClicked = (e) => {
    // prevent submit
    e.preventDefault();
    // get all inputs with this disable-button as id
    var inputsDisablingId = document.querySelectorAll(`input[${DISABLED_BUTTON_ATTRIBUTE}=${(event.target as any).id}], textarea[${DISABLED_BUTTON_ATTRIBUTE}=${(event.target as any).id}], select[${DISABLED_BUTTON_ATTRIBUTE}=${(event.target as any).id}], textarea[${DISABLED_BUTTON_ATTRIBUTE}=${(event.target as any).id}], div.form-element-radio-list[${DISABLED_BUTTON_ATTRIBUTE}=${(event.target as any).id}], div.form-element-checkbox-list[${DISABLED_BUTTON_ATTRIBUTE}=${(event.target as any).id}], div.form-element-input-date-picker[${DISABLED_BUTTON_ATTRIBUTE}=${(event.target as any).id}]` );
    var formToSubmit: HTMLFormElement;

    if (inputsDisablingId) {
        var blurEvent = createEvent('blur');
        var changeEvent = createEvent('change');

        // Check all inputs. This is a quick check to see if all inputs have values.
        // If not, a blur event is triggered to force full validation, as no value may be valid.
        [].forEach.call(inputsDisablingId, (element: HTMLElement) => {
            // check that all select inputs have a value, trigger blur event if not to force full validation
            if (element.tagName === 'SELECT') {
                if (!(element as HTMLSelectElement).value) {
                    let selectElement = element as HTMLSelectElement;

                    selectElement.dispatchEvent(changeEvent);
                }
            }
            // check that all inputs have values, trigger blur event if not to force full validation. Radio and checkbox lists are handled separately
            else if (element.tagName === 'INPUT' && (element as HTMLInputElement).type !== 'radio' && (element as HTMLInputElement).type !== 'checkbox') {
                if (!(element as HTMLInputElement).value) {
                    element.dispatchEvent(blurEvent);

                }
            }
            // check that all textareas have values, trigger blur event if not to force full validation
            else if (element.tagName === 'TEXTAREA') {
                if ((element as HTMLInputElement).type !== 'radio') {
                    if (!(element as HTMLInputElement).value) {
                        element.dispatchEvent(blurEvent);
                    }
                }

            }
            // check that all radio lists have a value selected, trigger blur event if not to force full validation
            else if (element.classList.contains('form-element-radio-list')) {
                var inputElementValidation =validateRadioAndCheckSubmission(element);
                if (!inputElementValidation) {
                    radioAndCheckValidationEvent(e, '.form-element-radio-list', 'input.form-element-radio');
                }
            }
            // check that all checkbox lists have a value selected, trigger blur event if not to force full validation
            else if (element.classList.contains('form-element-checkbox-list')) {
                var inputElementValidation = validateRadioAndCheckSubmission(element);
                if (!inputElementValidation) {
                    radioAndCheckValidationEvent(e, '.form-element-checkbox-list', 'input.form-element-checkbox');
                }
            }
            // check that all date pickers have a value, trigger blur event if not to force full validation
            else if (element.classList.contains("form-element-input-date-picker")) {
                var inputList = element.getElementsByTagName('input');
                if (inputList.length > 0) {
                    var input = inputList[0];
                    if (!(input as HTMLInputElement).value) {
                        dateValidationEvent(e);
                    }
                }
            }
        });
    }

    let submitButton: HTMLInputElement = e.currentTarget as HTMLInputElement;
    formToSubmit = submitButton.form;
    if (formToSubmit && noErrorsPreSubmit() && !submitButton.hasAttribute('data-modal-trigger')) {
        formToSubmit.submit()
    }
}

// check if any elements have the invalid class
const noErrorsPreSubmit = () => {
    var invalidElements = document.querySelectorAll(`.${formElementInvalidClass}`);

    if (invalidElements.length > 0) {
        return false;
    } else {
        return true;
    }
}

const hasError = (input: HTMLElement) => {
    return input.closest(`.${FORM_ELEMENT_CLASS}`).classList.contains(formElementInvalidClass);
}

// Add event listeners to input elements
const inputValidation = function () {
    var formElement = document.getElementsByTagName('input');

    for (let i = 0; i < formElement.length; i++) {
        if (formElement[i].classList.contains('form-element-input')
            && (formElement[i].type == 'text'
                || formElement[i].type == 'email'
                || formElement[i].type == 'tel'
                || formElement[i].type == 'url')) {
            formElement[i].addEventListener('blur', function (e) {
                inputValidationEvent(e)
            }, false);
        } else if (formElement[i].classList.contains('form-element-input') && (formElement[i].type == 'number')) {
            formElement[i].addEventListener('blur', function (e) {
                inputNumberValidationEvent(e)
            }, false);

        }
    }
}

// Full validation for input elements. Excludes radio and checkbox lists
const inputValidationEvent = function (e) {
    let formElement = e.currentTarget as HTMLInputElement;
    let inputValue = formElement.value,
        isEmpty = !hasValue(inputValue),
        inputType = formElement.type,
        isPostalCode = formElement.hasAttribute(PostalCodeAttribute),
        isDOB = formElement.hasAttribute('data-dob-validation'),
        isRequired = formElement.hasAttribute('required');
    var isValid = isEmpty && !isRequired;

    if (!isEmpty) {
        let countryCombination: CountryCombination = null;

        if (inputType === 'tel' || isPostalCode) {
            countryCombination = getCountryCombination(formElement, inputType, !isPostalCode);
        }

        isValid = regularExpressionValidator(inputValue, inputType, countryCombination, isPostalCode, isDOB);
    }

    validateToggle(isValid, formElement, isEmpty);
}

const getCountryCombination = function (element: HTMLInputElement, inputType: string, checkUsOrCanada: boolean) {
    if (!element) {
        return null;
    }

    let countryElement: HTMLSelectElement;
    if (inputType === 'tel') {
        let countryNumberContainer = element.closest(".country-number-container");
        if (countryNumberContainer) {
            countryElement = countryNumberContainer.querySelector("[data-number-country]") as HTMLSelectElement;
        }
    }
    else {
        countryElement = document.querySelector("[data-form-validation-country]") as HTMLSelectElement;
    }

    if (countryElement && countryElement.value) {
        let countryName = countryElement.options[countryElement.selectedIndex].innerHTML.toLowerCase().replace(' ', '');

        if (checkUsOrCanada && (countryName === UnitedStates || countryName === Canada)) {
            return CountryCombination.USOrCanada;
        }

        if (countryName === UnitedStates) {
            return CountryCombination.US;
        }

        if (countryName === Canada) {
            return CountryCombination.Canada;
        }
    }

    return null;
}

// add event listeners to radio buttons to reset error state when a value is clicked
const inputRadioErrorInitialization = function () {

    var formElement = document.querySelectorAll(".form-element-radio");

    // add events to validate
    for (let i = 0; i < formElement.length; i++) {
        (formElement[i] as HTMLInputElement).addEventListener('click', (e) => {
            removeRadioAndCheckError(e, '.form-element-radio-list')
        });
    }
}

// add event listeners to checkbox buttons to reset error state when a value is clicked
const inputCheckboxInitialization = function () {

    var formElement = document.querySelectorAll(".form-element-checkbox");

    // add events to validate
    for (let i = 0; i < formElement.length; i++) {
        (formElement[i] as HTMLInputElement).addEventListener('click', (e) => {
            removeRadioAndCheckError(e, '.form-element-checkbox-list')
        });
    }
}

// Remove the error class when a radio or checkbox is clicked
const removeRadioAndCheckError = function (event: Event, elementClass: string) {
    var element = (event.target as HTMLElement);
    let elementList = element.closest(elementClass) as HTMLElement;
    if (elementList) {
        elementList.classList.remove(formElementInvalidClass);
        elementList.classList.add(formElementValidClass);
    }
    // If element has disable-button attribute set, button should be enabled
    enableSubmitButtons(elementList);
}

// Remove the error class when a date is selected (fired on blur).
const removeDateError = function (input: HTMLElement) {
    var element = input.closest('.form-element-input-date-picker') as HTMLElement;
    element.classList.remove(formElementInvalidClass);
    element.classList.add(formElementValidClass);
    // remove the blur handler, we will assume that the user has provided a value. If not,
    // submission checking will catch it anyway.
    input.removeEventListener('blur', dateChangeHandler);
    // If element has disable-button attribute set, button should be enabled
    enableSubmitButtons(element);
}

// Validate that required Radio and Checkbox Lists have a value selected
const radioAndCheckValidationEvent = function (event: Event, listSelector: string, inputSelector: string) {
    var formElementList = document.querySelectorAll(listSelector);

    // Look through lists and check if they are required and have a value selected to determine if they are valid
    for (let i = 0; i < formElementList.length; i++) {
        var options = formElementList[i].querySelectorAll(inputSelector) as NodeListOf<HTMLInputElement>;
        var getRequired = false;

        if (formElementList[i].getAttribute('required') !== null) {
            getRequired = true;
        }
        var isValid = !getRequired;
        for (let n = 0; n < options.length; n++) {
            if (options[n].checked) {
                isValid = true;
                break;
            }
        }

        validateToggleRadiosAndChecks(isValid, formElementList[i] as HTMLElement, getRequired);
    }
}

// Click event handler for date changes to remove error class
const dateChangeHandler = function (event: Event) {
    removeDateError(event.target as HTMLElement)
}

// Validate that a date has been selected for required date fields
const dateValidationEvent = function (event: Event) {
    var dateContainers = document.querySelectorAll('.form-element-input-date-picker');
    for (let i = 0; i < dateContainers.length; i++) {
        var input = dateContainers[i].querySelector('input');
        var isEmpty = !hasValue(input.value);
        var isRequired = dateContainers[i].getAttribute('required') !== null;
        var isValid = !isRequired || !isEmpty;
        // we cannot assign the event listener at intitialization because the element is not loaded
        // so we add the event listener now if invalid so that we can re-enable submit when changed.
        if (!isValid) {
            input.addEventListener('blur', dateChangeHandler)
        }
        validateToggle(isValid, dateContainers[i] as HTMLElement, isRequired)
    }
}

// Validate that a number has been entered for required number fields
const inputNumberValidationEvent = function (e) {
    let formElement = e.currentTarget as HTMLInputElement;
    let isEmpty = formElement.value ? false : true;
    var isRequired = formElement.getAttribute('required') !== null;
    let isValid = !isRequired || !isEmpty;

    validateToggle(isValid, formElement, isEmpty);
}

// Add event listeners to textareas to trigger validation on blur
const textareaValidation = function () {
    var formElement = document.getElementsByTagName('textarea');

    for (let i = 0; i < formElement.length; i++) {
        if (formElement[i].classList.contains('form-element-textarea')) {
            formElement[i].addEventListener('blur', function () { textareaValidationEvent(formElement[i]) }, false);
        }
    }
}

// Validate that required textareas have a value
const textareaValidationEvent = function (formElement: HTMLTextAreaElement) {
    let textareaValue = formElement.value,
        isEmpty = !hasValue(textareaValue),
        inputType = 'textarea';
    var isRequired = formElement.getAttribute('required') !== null;
    let isValid = !isRequired || !isEmpty;

    if (!isEmpty) {
        isValid = regularExpressionValidator(textareaValue, inputType);
    }
    validateToggle(isValid, formElement, isRequired);
}

// Add event listeners to select elements to trigger validation on change
const selectValidation = function () {
    var formElement = document.getElementsByTagName('select');

    for (let i = 0; i < formElement.length; i++) {

        if (formElement[i].classList.contains('form-element-select')) {

            let selectElement = formElement[i] as HTMLSelectElement;
            let selectElementId = selectElement.id;

            formElement[i].addEventListener('change', function () { selectValidationEvent(formElement[i]) }, false);

        }
    }
}

// Validate that required select elements have a value
const selectValidationEvent = function (formElement: HTMLSelectElement) {
    let element: HTMLSelectElement = formElement;
    let selectedValue = element.value;
    let elementId = element.id;

    let isEmpty = !hasValue(selectedValue),
        validateStatus = false;

    if (!isEmpty && selectedValue !== 'no-validate') {
        validateStatus = true;
    }

    if (elementId == 'states') {
        let countryElement = document.getElementById('countries');
        let countryElementValue = (countryElement as HTMLSelectElement).value;
        let countryElementValueIsEmpty = !hasValue(countryElementValue);

        if (countryElementValueIsEmpty || !element.required || !isEmpty) {
            validateStatus = true;
        } else {
            validateStatus = false;
        }
    }

    validateToggle(validateStatus, element, isEmpty && element.hasAttribute("required"));

    if (element.hasAttribute("data-number-country")) {
        let countryNumberContainer = element.closest('.country-number-container');
        if (countryNumberContainer) {
            let numberElement = countryNumberContainer.querySelector('input');
            if (numberElement && numberElement.value) {
                let blurEvent = createEvent('blur');
                numberElement.dispatchEvent(blurEvent);
            }
        }
    }
}

// Helper function to do quick validation of radio and checkbox lists on submission
function validateRadioAndCheckSubmission(element: HTMLElement) {
    var inputElements = element.getElementsByTagName('input');
    var inputElementValidation = false;
    for (let i = 0; i < inputElements.length; i++) {
        if (inputElements[i].checked) {
            inputElementValidation = true;
        }
    }
    return inputElementValidation;
}

// global validate toggle used to add/remove validation related classes
export function validateToggle(isValid: boolean, el: HTMLElement, isRequiredError: boolean) {
    let parentEl = el.closest(`.${FORM_ELEMENT_CLASS}`);

    if (isValid) {
        parentEl.classList.remove(formElementInvalidClass);
        parentEl.classList.add(formElementValidClass);
        // If element has disable-button attribute set, button should be enabled
        enableSubmitButtons(el);

    } else {
        var errorTextEl = parentEl.querySelector(`.${FORM_ELEMENT_ERROR_CLASS}`);
        if (errorTextEl.innerHTML && hasValue(errorTextEl.innerHTML.trim()) && !elementOnlyContainsEmptySpan(errorTextEl)) {
            //Check empty span case, because some form inputs are set up with an empty span error element, which returns as having a value in the 'hasValue' check.
            //(If there is an empty span, the code should go into the next cases.)
            parentEl.classList.add(formElementInvalidClass);
            parentEl.classList.remove(formElementValidClass);
        }
        else if (isRequiredError && el.getAttribute('required') != null) {
            parentEl.classList.add(formElementInvalidClass);
            parentEl.classList.remove(formElementValidClass);
            errorTextEl.innerHTML = (window as any).errorText.requiredErrorText;
        }
        else if (!isRequiredError) {
            parentEl.classList.add(formElementInvalidClass);
            parentEl.classList.remove(formElementValidClass);
            errorTextEl.innerHTML = (window as any).errorText.invalidErrorText;
        }

        // If button to disable isn't disabled, disable it
        disableSubmitButton(el);
    }

    function elementOnlyContainsEmptySpan(element: Element) {
        let children = element.children;
        if (children.length == 1 && children[0].tagName === 'SPAN') {
            //Only contains span. Check if the span is empty.
            return children[0].textContent.trim() === "";
        }
        return false;
    }
}

// global validate toggle used to add/remove validation related classes for radio and checkbox lists
export function validateToggleRadiosAndChecks(isValid: boolean, el: HTMLElement, isRequiredError: boolean) {
    let parentEl = el;

    if (isValid) {
        parentEl.classList.remove(formElementInvalidClass);
        parentEl.classList.add(formElementValidClass);
        // If element has disable-button attribute set, button should be enabled
        enableSubmitButtons(el);

    } else {
        if (isRequiredError) {
            parentEl.classList.add(formElementInvalidClass);
            parentEl.classList.remove(formElementValidClass);
            parentEl.querySelector(`.${FORM_ELEMENT_ERROR_CLASS}`).innerHTML = (window as any).errorText.requiredErrorText;
        }
        else if (!isRequiredError) {
            parentEl.classList.add(formElementInvalidClass);
            parentEl.classList.remove(formElementValidClass);
            parentEl.querySelector(`.${FORM_ELEMENT_ERROR_CLASS}`).innerHTML = (window as any).errorText.invalidErrorText;

            // If button to disable isn't disabled, disable it
            disableSubmitButton(el);

        }

    }
}

// Get the disable button for an element
function getDisableButton(el: HTMLElement) {
    let disableButtonId = getDisableButtonId(el);
    return disableButtonId ? document.getElementById(disableButtonId) : null;
}

// Get the id of the button to disable for an element
function getDisableButtonId(el: HTMLElement) {
    if (el.hasAttribute(DISABLED_BUTTON_ATTRIBUTE) && el.attributes[DISABLED_BUTTON_ATTRIBUTE].value.length > 0) {
        return el.attributes[DISABLED_BUTTON_ATTRIBUTE].value;
    }

    return null;
}

/// If an input has the disable-button attribute set, try to disable that button
export function disableSubmitButton(el: HTMLElement) {
    let buttonToDisable = getDisableButton(el) as HTMLElement;
    if (buttonToDisable != null && !buttonToDisable.classList.contains(DISABLED_BUTTON_CLASS))
        buttonToDisable.classList.add(DISABLED_BUTTON_CLASS);
}

/// If an input has the disable-button attribute set, try to enable that button
export function enableSubmitButtons(el: HTMLElement) {
    let buttonToDisable = getDisableButton(el) as HTMLElement;
    let otherInputDivs = document.getElementsByClassName(formElementInvalidClass);

    if (buttonToDisable != null && otherInputDivs.length == 0) {
        let disableButtonId = getDisableButtonId(el);
        let buttonHasOtherInputsDisablingIt = false;
        // Check if any other elements are also disabling the button that this element wants to disable
        [].forEach.call(otherInputDivs, otherInputDiv => {
            var input = otherInputDiv.querySelector('input:first-of-type');
            var select = otherInputDiv.querySelector('select:first-of-type')
            if ((input != null && input.attributes[DISABLED_BUTTON_ATTRIBUTE] && input.attributes[DISABLED_BUTTON_ATTRIBUTE].value === disableButtonId)
                || (select != null && select.attributes[DISABLED_BUTTON_ATTRIBUTE] && select.attributes[DISABLED_BUTTON_ATTRIBUTE].value === disableButtonId)) {
                buttonHasOtherInputsDisablingIt = true;
            }
        });
        // If no other elements are disabling this button and it's currently disabled, then enable it
        if (!buttonHasOtherInputsDisablingIt && buttonToDisable.classList.contains(DISABLED_BUTTON_CLASS)) {
            buttonToDisable.classList.remove(DISABLED_BUTTON_CLASS);
        }
    }
}

// Add event listeners to password fields to handle password validation
export function initializePasswordValidation() {
    var passwordInput = document.getElementById('passwordInput');
    var confirmPasswordInput = document.getElementById('confirmPasswordInput');

    if (typeof passwordInput != 'undefined' && passwordInput) {
        passwordInput.addEventListener('blur', function (e) { handlePasswordInputChange(e) });
    }
    if (typeof confirmPasswordInput != 'undefined' && confirmPasswordInput) {
        confirmPasswordInput.addEventListener('blur', function (e) { handleConfirmPasswordInputChange(e) });
    }
}

// Handler for password input change
function handlePasswordInputChange(e) {
    var passwordInputElement: HTMLInputElement = e.currentTarget;
    var confirmPasswordInputElement: HTMLInputElement = document.getElementById('confirmPasswordInput') as HTMLInputElement;

    if (confirmPasswordInputElement && typeof confirmPasswordInputElement != 'undefined') {
        validatePassword(passwordInputElement, confirmPasswordInputElement);
    }
}

// Handler for confirm password input change
function handleConfirmPasswordInputChange(e) {
    var confirmPasswordInputElement: HTMLInputElement = e.currentTarget;
    var passwordInputElement: HTMLInputElement = document.getElementById('passwordInput') as HTMLInputElement;

    if (passwordInputElement && typeof passwordInputElement != 'undefined') {
        validatePassword(passwordInputElement, confirmPasswordInputElement);
    }
}

// Validate password and confirm password fields
function validatePassword(passwordInputElement: HTMLInputElement, confirmPasswordInputElement: HTMLInputElement) {
    let passwordErrorDiv: HTMLElement = (passwordInputElement.parentNode.parentNode as HTMLElement).querySelector('.form-element-error') as HTMLElement;
    let confirmPasswordErrorDiv: HTMLElement = (confirmPasswordInputElement.parentNode.parentNode as HTMLElement).querySelector('.form-element-error') as HTMLElement;

    let passwordFormElement = passwordInputElement.closest(`.${FORM_ELEMENT_CLASS}`) as HTMLElement;
    let confirmFormElement = confirmPasswordInputElement.closest(`.${FORM_ELEMENT_CLASS}`) as HTMLElement;

    let hasError = false;

    let invalidPasswordText = (window as any).errorText.invalidPasswordText;
    let passwordMatchErrorText = (window as any).errorText.passwordMatchErrorText;

    if (confirmPasswordInputElement.value && passwordInputElement.value !== confirmPasswordInputElement.value) {
        hasError = true;
        confirmPasswordErrorDiv.querySelector(`.${FORM_ELEMENT_ERROR_CLASS}`).innerHTML = passwordMatchErrorText;
        activateErrorElement(confirmFormElement);
    }
    else if (confirmPasswordInputElement.value && passwordInputElement.value === confirmPasswordInputElement.value) {
        deactivateErrorElement(confirmFormElement);

    }
    else { // required error
        hasError = true;
        validateToggle(false, confirmPasswordInputElement, true);
    }

    if (passwordInputElement.value &&
        !isValidPassword(passwordInputElement.value)) {
        hasError = true;
        passwordErrorDiv.querySelector(`.${FORM_ELEMENT_ERROR_CLASS}`).innerHTML = invalidPasswordText;
        activateErrorElement(passwordFormElement);

    }
    else if (passwordInputElement.value && isValidPassword(passwordInputElement.value)) {
        deactivateErrorElement(passwordFormElement);
    }
    else { // required error
        hasError = true;
        validateToggle(false, passwordInputElement, true);
    }


    if (hasError) {
        disableSubmitButton(passwordInputElement);
    }
    else {
        enableSubmitButtons(passwordInputElement);
    }
}

// Add invalid class to element
function activateErrorElement(el: HTMLElement) {
    if (el && typeof el != 'undefined') {
        el.classList.add(formElementInvalidClass);
        el.classList.remove(formElementValidClass);
    }
}

// Remove invalid class from element
function deactivateErrorElement(el: HTMLElement) {
    if (el && typeof el != 'undefined') {
        el.classList.remove(formElementInvalidClass);
        el.classList.add(formElementValidClass);
    }
}

// Disable login button when clicked
const disableLoginButton = function () {
    let loginButton = document.querySelector('[data-login-submit]') as HTMLButtonElement;

    if (loginButton) {
        loginButton.addEventListener('click', () => {
            loginButton.disabled = true;
            loginButton.classList.add('disabled');
        });
    }
}